import { ChakraComponents as CC } from '@Modules/core/lib/chakra';
import DuplicateTransactionsFormHandle from '../containers/forms/transactions/DuplicateTransactionsFormHandle';
import UnprocessedTransactionsFormHandle from '../containers/forms/transactions/UnprocessedTransactionsFormHandle';
import ValidTransactionsDetailFormHandle from '../containers/forms/transactions/ValidTransactionsDetailFormHandle';
import ValidTransactionsSummaryFormHandle from '../containers/forms/transactions/ValidTransactionsSummaryFormHandle';
// Statistics
import AcquirerTransactionsByNetworkCardTypeFormHandle from '../containers/forms/transactions/statistics/acquirerTransactionsByNetworkCardType/AcquirerTransactionsByNetworkCardTypeFormHandle';
import BinTransactionsFormHandle from '../containers/forms/transactions/statistics/binTransactions/BinTransactionsFormHandle';
const Transactions = () => {
  return (
    <div>
      <CC.Box>
        <CC.Text fontSize={20} fontWeight="bold" mb="4">
        Transactions
        </CC.Text>
        <CC.Tabs>
          <div style={{overflowX: "auto"}}>
          <CC.TabList>
            <CC.Tab minWidth={'fit-content'}>Transactions non Traitées</CC.Tab>
            <CC.Tab minWidth={'fit-content'}>Transactions dupliquées</CC.Tab>
            <CC.Tab minWidth={'fit-content'}>Détail Transactions Valides</CC.Tab>
            <CC.Tab minWidth={'fit-content'}>Résumé Transactions Valides</CC.Tab>
          </CC.TabList>
          </div>

          <CC.TabPanels>
            <CC.TabPanel>
              <UnprocessedTransactionsFormHandle />
            </CC.TabPanel>
            <CC.TabPanel>
              <DuplicateTransactionsFormHandle />
            </CC.TabPanel>
            <CC.TabPanel>
              <ValidTransactionsDetailFormHandle />
            </CC.TabPanel>
            <CC.TabPanel>
              <ValidTransactionsSummaryFormHandle />
            </CC.TabPanel>
          </CC.TabPanels>
        </CC.Tabs>
      </CC.Box>

      <CC.Divider/>

      <CC.Box mt={10}>
        <CC.Text fontSize={20} fontWeight="bold" mb="4">
        Statistiques
        </CC.Text>
        <CC.Tabs>
          <div style={{overflowX: "auto"}}>
          <CC.TabList>
            <CC.Tab minWidth={'fit-content'}>Transactions acquéreur par type carte reseau</CC.Tab>
            <CC.Tab minWidth={'fit-content'}>Transactions par BIN</CC.Tab>            
          </CC.TabList>
          </div>

          <CC.TabPanels>
            <CC.TabPanel>
              <AcquirerTransactionsByNetworkCardTypeFormHandle />
            </CC.TabPanel>
            <CC.TabPanel>
              <BinTransactionsFormHandle />
            </CC.TabPanel>
            
          </CC.TabPanels>
        </CC.Tabs>
      </CC.Box>

    </div>
  )
}

export default Transactions;